import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

const url = "/api/v1/salary";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`${url}?${p}`);
  },

  calculate(params) {
    const p = paramsFactory(params);
    return api.get(`${url}/calculate?${p}`);
  },
  approved(data) {
    return api.put(`${url}/approved`, data);
  },
  paid(data) {
    return api.put(`${url}/paid`, data);
  },
  changeAttendance(data) {
    return api.put(`${url}/${data.salary_id}`, data);
  },
  checkSalaryStatus(date) {
    return api.get(`${url}/status?date=${date}`);
  },
  deleteByMonth(date) {
    return api.delete(`${url}/delete/${date}`);
  },
};
